import Setting from '@/pages/settings/Index';
import SafeSetting from '@/pages/settings/SafeSetting';
import UserInfo from '@/pages/settings/UserInfo';
import { IMenu } from '@/typings';

export default [
	{
		id: 'settings',
		url: '/settings',
		name: '我的设置',
		isLink: false,
		component: Setting,
	},
	{
		id: 'userInfo',
		url: '/settings/userInfo',
		name: '个人中心',
		component: UserInfo,
	},
	{
		id: 'safeSetting',
		url: '/settings/safeSetting',
		name: '安全设置',
		component: SafeSetting,
	},
] as IMenu[];
